import $http from '@/plugins/axios'
import { removeNamespace } from '@/utils/helpers'
import { ItemSearchType } from '@/utils/enums/item-enums'

export const PRODUCTS_TYPES = {
  mutations: {
    SET_LOADING: 'products/SET_LOADING',
    SET_PAGED_PRODUCTS: 'products/SET_PAGED_PRODUCTS',
    SET_TOTAL_PRODUCTS_COUNT: 'products/SET_TOTAL_PRODUCTS_COUNT',
    SET_PRODUCT_TABLE_OPTIONS: 'products/SET_PRODUCT_TABLE_OPTIONS',
    SET_SEARCH_TYPE: 'products/SET_SEARCH_TYPE',
    SET_DATA_SOURCE_FILTER: 'products/SET_DATA_SOURCE_FILTER'
  },
  actions: {
    fetchProductsPaged: 'products/fetchProductsPaged',
    changeSearchType: 'products/changeSearchType',
    fetchGiftCardsPaged: 'products/fetchGiftCardProducts',
    changeDataSourceFilter: 'products/changeDataSourceFilter'
  }
}

const _types = removeNamespace('products', PRODUCTS_TYPES)

const state = () => ({
  loading: false,
  productTableOptions: {
    page: 1,
    itemsPerPage: 10,
    keyword: '',
    searchType: ItemSearchType.Title,
    dataSourceFilter: []
  },
  pagedProducts: [],
  totalProductsCount: 0
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_PRODUCTS] (state, pagedResult) {
    state.pagedProducts = pagedResult
  },
  [_types.mutations.SET_TOTAL_PRODUCTS_COUNT] (state, count) {
    state.totalProductsCount = count
  },
  [_types.mutations.SET_PRODUCT_TABLE_OPTIONS] (state, options) {
    state.productTableOptions = options
  },
  [_types.mutations.SET_SEARCH_TYPE] (state, type) {
    state.productTableOptions.searchType = type
  },
  [_types.mutations.SET_DATA_SOURCE_FILTER] (state, value) {
    state.productTableOptions.dataSourceFilter = value
  }
}

const actions = {
  [_types.actions.fetchProductsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page, keyword, searchType, dataSourceFilter } = state.productTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return $http().post(`admin/items`, {
      skipCount,
      maxResultCount,
      keyword,
      searchType,
      dataSourceFilter
    })
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_PRODUCTS, items)
        commit(_types.mutations.SET_TOTAL_PRODUCTS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchGiftCardsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    // const { itemsPerPage, page, keyword, searchType } = state.productTableOptions
    // const maxResultCount = itemsPerPage
    // const skipCount = (page - 1) * itemsPerPage
    return $http().get(`admin/products`)
      .then((res) => {
        const items = res
        commit(_types.mutations.SET_PAGED_PRODUCTS, items)
        commit(_types.mutations.SET_TOTAL_PRODUCTS_COUNT, 6)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.changeSearchType] ({ state, commit, dispatch }, searchType) {
    commit(_types.mutations.SET_SEARCH_TYPE, searchType)
  },
  [_types.actions.changeDataSourceFilter] ({ commit }, value) {
    commit(_types.mutations.SET_DATA_SOURCE_FILTER, value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
